export const listening = {
    uk: {
        header: "Аудіювання",
        listOfTopics: "Список тем"
    },
    en: {
        header: "Listening",
        listOfTopics: "List of Topics"
    }
}